import { cx } from "./ui";

/**
 * The brand mark, everywhere a placeholder "WS" square used to stand in for
 * it: the sidebar, the mobile header, and every auth-adjacent page a visitor
 * lands on signed out. One file, one asset, so a rebrand is a single swap.
 */
export function LogoMark({ className }: { className?: string }) {
  return <img src="/logo-mark.png" alt="" className={cx("shrink-0 object-contain", className)} />;
}
